export const scrollToPageTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "auto"
  });
};
